import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivArrowWrapper = styled.div<{ isOpen: boolean }>`
  border: 1px solid ${COLOR.GRAY200.code};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  width: 26px;
  height: 26px;
  min-width: 26px;
  transform: rotate(${({ isOpen }) => (isOpen ? "-180deg" : "0deg")});
  transition: 0.15s;
`;
